export default __webpack_public_path__ + "static/media/ceramol-acn3-actiseb-mousse.e5ac0007.png";